import React, { useEffect, useState } from 'react';
import './patientForm.css';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import PatientDemoGraphics from './PatientForms/PatientDemoGraphics'
import AllregiesAndReasonForVisit from './PatientForms/AllregiesAndReasonForVisit'
import EmergencyContactandPhysician from './PatientForms/EmergencyContactandPhysician'
import InsuranceAndId from './PatientForms/InsuranceAndId'
import ProgressForm from './progressForm';
import { CommonDataType } from '@custom/Utils/constants/interfaces';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _patientUrls } from '@custom/Utils/constants/apiUrls';
import { customStyle } from '@custom/Utils/utils';
import { useTheme } from "../../ui/src/contextProviders"

const PatientRegistration = () => {
  const location = useLocation();
  const data = useLocation();
  const isDarkMode = useTheme();
  const [PageNumber, setPageNumber] = useState(1);
  const [patientDocID, setPatientDocID] = useState('');
  const [patient, setPatient] = useState({});
  const [commonData, setCommonData] = useState<CommonDataType>();
  const [contactNumber, setContactNumber] = useState('');
  const [patientName, setPatientName] = useState('');
  const [patientUHID, setPatientUHID] = useState('');
  const [patientData, setPatientData] = useState('');

  const getPatientList = async () => {
    let response: any = await apiRequest({
      method: 'GET',
      endUrl: _patientUrls.list,
      query: {
        limit: 10, offset: 1, patientId: patientDocID, hospitalId: sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId'), searchQ: '', fromDate: '', toDate: ''
      }
    })
    if (response?.status) {
      setPatient(response?.result?.list?.[0])
    }
  }
  useEffect(() => {
    if (data.state?.mode == 'create' && patientDocID) {
      getPatientList()
    }
  }, [PageNumber])

  return (
    <>
      <div className='page page__full' style={
        isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header isBack={true} title={`${data.state?.mode == 'create' ? 'Add' : 'Edit'} Patient Details`}></Header>
        <div className='page__body'>
          <div className='details'>
            <div className='form form--innersec'>
              <ProgressForm PageNumber={PageNumber} />
              {PageNumber == 1 && <PatientDemoGraphics patient={patient} setPatient={setPatient} commonData={commonData} setCommonData={setCommonData} setPatientDocID={setPatientDocID} patientDocID={patientDocID} PageNumber={PageNumber} setPageNumber={setPageNumber} setContactNumber={setContactNumber} setPatientName={setPatientName} setPatientUHID={setPatientUHID} setPatientData={setPatientData} />}
              {PageNumber == 2 && <InsuranceAndId patient={patient} setPatient={setPatient} commonData={commonData} setCommonData={setCommonData} setPatientDocID={setPatientDocID} patientDocID={patientDocID} PageNumber={PageNumber} setPageNumber={setPageNumber} />}
              {PageNumber == 3 && <EmergencyContactandPhysician patient={patient} setPatient={setPatient} commonData={commonData} setCommonData={setCommonData} setPatientDocID={setPatientDocID} patientDocID={patientDocID} PageNumber={PageNumber} setPageNumber={setPageNumber} />}
              {PageNumber == 4 && <AllregiesAndReasonForVisit patient={patient} setPatient={setPatient} commonData={commonData} setCommonData={setCommonData} setPatientDocID={setPatientDocID} patientDocID={patientDocID} PageNumber={PageNumber} setPageNumber={setPageNumber} contactNumber={contactNumber} patientName={patientName} patientUHID={patientUHID} userRole={location?.state?.userRole} patientData={patientData} />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PatientRegistration
